import loadable from '@loadable/component'

export const LazyPuzzlesListing = loadable(() => import('./PuzzleListing'))
